import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { supabase } from '../lib/supabase'

export default function ForgotPassword() {
  const [email, setEmail]     = useState('')
  const [loading, setLoading] = useState(false)
  const [sent, setSent]       = useState(false)
  const [error, setError]     = useState('')

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')
    setLoading(true)

    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: `${window.location.origin}/reset-password`,
    })

    if (error) setError(error.message)
    else setSent(true)
    setLoading(false)
  }

  return (
    <div className="auth-layout">
      <div className="auth-panel">
        <div className="auth-panel-content">
          <div className="auth-logo">
            <div className="auth-logo-mark">↑</div>
            <span className="auth-logo-name">Uplift</span>
          </div>
          <h1>Reset your password</h1>
          <p>Enter the email address linked to your account and we'll send you a link to reset your password.</p>
          <div className="auth-panel-features">
            <div className="auth-feature">
              <div className="auth-feature-icon">📧</div>
              Check your inbox for the link
            </div>
            <div className="auth-feature">
              <div className="auth-feature-icon">⏱</div>
              Link expires in 1 hour
            </div>
            <div className="auth-feature">
              <div className="auth-feature-icon">🔒</div>
              Secure reset — no old password needed
            </div>
          </div>
        </div>
      </div>

      <div className="auth-form-side">
        <div className="auth-card">
          <div className="auth-card-logo">
            <div className="auth-card-logo-mark">↑</div>
            <span className="auth-card-logo-name">Uplift</span>
          </div>
          <h2>Forgot password?</h2>
          <p className="subtitle">We'll email you a reset link</p>

          {error && <div className="alert alert-error">⚠ {error}</div>}

          {sent ? (
            <div className="alert alert-success">
              ✓ Reset link sent! Check your email inbox (and spam folder just in case). Click the link to set a new password.
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Email address</label>
                <input
                  type="email" required
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  placeholder="you@example.com"
                  autoComplete="email"
                />
              </div>
              <button className="btn btn-primary" type="submit" disabled={loading}>
                {loading ? 'Sending…' : 'Send reset link →'}
              </button>
            </form>
          )}

          <div className="auth-link">
            Remembered it? <Link to="/login">Back to sign in</Link>
          </div>
        </div>
      </div>
    </div>
  )
}
